window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function ($) {
  $(function () {
    REBASE.theme.bindProductControls();
    REBASE.theme.is_mobile = window.innerWidth < 1040;
  });

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Setup Product page controls (needs to run on product pages and when quickview is opened)
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  REBASE.theme.handleizeStr = function (str) {
    if (str === null || typeof str === "undefined") {
      return "";
    }
    str = str.toLowerCase();

    // list of special characters we want to drop completely
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    // all non-alphanumeric and non-underscore
    str = str.replace(/\W+/g, "-");

    // if last character is a hyphen, drop it
    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    // if first character is a hyphen, drop it
    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str;
  };

  REBASE.theme.appendToFilename = function (filename, str) {
    var dot_indx = filename.lastIndexOf(".");

    if (dot_indx === -1) {
      return filename + str;
    } else {
      return (
        filename.substring(0, dot_indx) + str + filename.substring(dot_indx)
      );
    }
  };

  REBASE.theme.unbindProductControls = function () {
    $(".product-header__reviews, .product-info__tabs a").off(".rbProduct");
  };

  REBASE.theme.initProductGallery = function () {
    // Image Galleries
    REBASE.theme.product_photo_gallery = new Swiper('.gallery', {
      loop: true,
      speed: 300,
      navigation: {
        nextEl: '.gallery-button__next',
        prevEl: '.gallery-button__prev',
      },
      breakpoints: {
        640: {
          autoHeight: true,
        },
        768: {
          autoHeight: true,
        },
        1024: {
          autoHeight: false,
        },
      },
    });
    $(".product__part--gallery").css({ opacity: 1 });
  };

  REBASE.theme.bindProductControls = function () {
    $(document).on("click", ".product-action__qty-minus", function (e) {
      e.preventDefault();
      var el = $("#quantity"),
        newValue = parseInt(el.val()) - 1;
      if (newValue >= 1) {
        el.val(newValue);
      }
    });

    $(document).on("click", ".product-action__qty-plus", function (e) {
      e.preventDefault();
      var el = $("#quantity");
      el.val(parseInt(el.val()) + 1);
    });

    $(document).on("click", ".gallery-thumb", function (e) {
      var _this = $(this);
      e.preventDefault();
      _this.addClass("active").siblings().removeClass("active");
      REBASE.theme.product_photo_gallery.slideToLoop(_this.data("index"));
    });

    // Image Galleries
    REBASE.theme.initProductGallery();

    // Option Selectors & Swatches
    // NOTE: must come after image gallery (for selected variant to show correct image when loading page)
    product = new REBASE.theme.Product({
      $container: $("#add-to-cart-form"),
    });
  };

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product class
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Product = (function () {
    function Product(options) {
      var inputs, input_type;

      this.variants = null;
      this.$container = options.$container;
      this.data = JSON.parse(
        document.getElementById("product__json").innerHTML
      );
      this.images = this.data.images;
      this.media = this.data.media;

      this.settings = {
        single_option_selector: ".single-option-select",
        original_select_id: "select#product-select",
      };

      if (this.data) {
        this._initVariants();

        // Trigger change to sync up images, etc on initial page load
        inputs = $(this.settings.single_option_selector, this.$container);
        input_type = inputs.first().attr("type");

        if (input_type === "radio" || input_type === "checkbox") {
          inputs.filter(":checked:first").trigger("change");
        } else {
          inputs.first().trigger("change");
        }
      } else {
        if (console) {
          console.log("Missing product json data!");
        }
      }
    }

    Product.prototype = $.extend({}, Product.prototype, {
      _initVariants: function () {
        var options = {
          $container: this.$container,
          enable_history_state: true,
          single_option_selector: this.settings.single_option_selector,
          original_select_id: this.settings.original_select_id,
          product: this.data,
        };

        this.variants = new REBASE.theme.Variants(options);
        this.$container.on("variantChange", this._updateAddToCart.bind(this));
        this.$container.on("variantChange", this._updateSku.bind(this));
        this.$container.on("variantChange", this._updateUpsell.bind(this));
        this.$container.on(
          "variantChange",
          this._updateVariantMetaFields.bind(this)
        );
        this.$container.on("variantImageChange", this._updateMedia.bind(this));
        this.$container.on("variantPriceChange", this._updatePrice.bind(this));
      },

      _updateVariantMetaFields: function (e) {
        const variant = e.variant.id;
        // If variant ID does not exist, dont do anything
        if (!variant) {
          return;
        }

        const variantMetaFields = JSON.parse(
          document.querySelector("[data-product-json]").innerHTML
        );
        const accordionIndexes = [];
        Object.values(variantMetaFields[variant]).forEach(
          (accordion, index) => {
            if (accordion.title !== "") {
              accordionIndexes.push(index);
            }
          }
        );

        /**
         * Show default product metafield accordions and remove product variant accordions if variant doesnt exist
         * in variantMetaFields or if current variant accordion_1 title does not exist.
         */

        if (
          variantMetaFields[variant] === undefined ||
          !accordionIndexes.length
        ) {
          document
            .querySelectorAll(".non-variant-accordion")
            .forEach((el) => el.classList.remove("hidden"));
          document
            .querySelectorAll(".variant-accordion")
            .forEach((el) => el.remove());
          return;
        }

        /**
         * Returns accordion markup for product variant metafields
         */
        const accordionMarkup = (accordion) => {
          // For Each accordion Content
          accordion.map((acc, index) => {
            const variantTitle = e.variant.title
              .split(" ")
              .join("-")
              .trim()
              .toLowerCase();
            const accordionContent = document.querySelectorAll(
              `.${variantTitle}-bullet-content`
            );
            let accordionBullets = "";

            if (index === 0) {
              const bullets = document.querySelectorAll(
                `.${variantTitle}-bullet-text`
              );
              const icons = document.querySelectorAll(
                `.${variantTitle}-bullet-icon`
              );
              for (i = 0; i < bullets.length; i++) {
                accordionBullets += `
                  <div class="toggle__bullet">
                    <span>${icons[i].innerHTML}</span>
                    <h2 class="tu h6 fw1 ls4">${bullets[i].innerHTML}</h2>
                  </div>
                `;
              }
            }

            if (acc.title) {
              const markUp = `
              <div class="toggle variant-accordion">
                <div class="toggle__label h5">${
                  accordion[index].title
                } <span>&plus;</span></div>
                <div class="toggle__content">
                  ${index === 0 ? accordionBullets : ""}
                  ${index !== 0 ? accordionContent[index - 1].innerHTML : ""}
                </div>
              </div>
              `;
              const toggles = document.querySelectorAll(".toggles");
              toggles[0].insertAdjacentHTML("beforeend", markUp);
            }
          });
        };

        /**
         * Remove variant accordions
         */
        document
          .querySelectorAll(".variant-accordion")
          .forEach((el) => el.remove());

        /**
         * If product variant exists in variantMetaFields, hide default product metafields and show variant product metafields
         */
        if (variant in variantMetaFields && accordionIndexes.length) {
          const nonVariantAccordion = document.querySelectorAll(
            ".non-variant-accordion"
          );
          nonVariantAccordion.forEach((el) => el.classList.remove("hidden"));
          accordionIndexes.forEach((i) => {
            if (nonVariantAccordion.length) {
              nonVariantAccordion[i].classList.add("hidden");
            }
          });
          accordionMarkup(Object.values(variantMetaFields[variant]));
        }
      },

      _updateSku: function (e) {
        $(".sku span").text(e.variant.sku);
      },

      _updateUpsell: function (e) {
        var variant = e.variant,
          currentProd = $(".upsells-list-item--current");

        if (currentProd.length) {
          currentProd.data("variant", variant.id);
          currentProd.data("price", variant.price);
          currentProd
            .find(".upsells-list-item__image img")
            .attr(
              "src",
              Shopify.resizeImage(variant.featured_image.src, "300x")
            );
          currentProd
            .find(".upsells-list-item__price")
            .text(
              Shopify.formatMoney(variant.price, "${{amount_no_decimals}}")
            );
          window.updateUpsellUI();
        }
      },

      _updatePrice: function (e) {
        var variant = e.variant;

        $(".product-price:not(.product-price--old)").html(
          Shopify.formatMoney(variant.price, "")
        );
        if (variant.price < variant.compare_at_price) {
          $(".product-price--old").html(
            Shopify.formatMoney(variant.compare_at_price, "")
          );
          $(".product-price:not(.product-price--old)").addClass(
            "product-price--on-sale"
          );
        } else {
          $(".product-price--old").html("");
          $(".product-price:not(.product-price--old)").removeClass(
            "product-price--on-sale"
          );
        }
      },

      _updateAddToCart: function (e) {
        var variant = e.variant,
          all_variants_match_option1 = e.all_variants_match_option1,
          target = $(e.target),
          input_type = target.attr("type"),
          btn = $("#add-to-cart"),
          btn_txt = $("#add-to-cart-text");

        if (!variant) {
          btn.addClass("disabled").attr("disabled", "disabled");
          btn_txt.text("Not Available");
        } else {
          if (variant.available) {
            btn.removeClass("disabled").removeAttr("disabled");
            btn_txt.text(btn_txt.data("add-to-cart-text"));
          } else {
            btn.addClass("disabled").attr("disabled", "disabled");
            btn_txt.text(btn_txt.data("sold-out-text"));
          }
        }

        if (input_type === "radio" || input_type === "checkbox") {
          target
            .parent(".swatch-element")
            .addClass("selected-swatch")
            .siblings()
            .removeClass("selected-swatch");

          // MODDED FOR SWATCH AVAILABILITY (only one level deep, option2)
          var option2_inputs = $('input[data-index="option2"]'),
            option2_vals = option2_inputs
              .map(function () {
                return $(this).val();
              })
              .get(),
            option2_not_available = $.map(option2_vals, function (option_val) {
              var is_available = false;

              $.each(all_variants_match_option1, function (i, match_variant) {
                if (match_variant.option2 === option_val) {
                  if (match_variant.available) {
                    is_available = true;
                  }
                }
              });

              if (is_available) {
                return undefined;
              } else {
                return option_val;
              }
            });

          option2_inputs
            .parent(".swatch-element")
            .removeClass("swatch--unavailable");
          option2_inputs
            .parent(".dropdown__option")
            .removeClass("dropdown__option--sold-out")
            .find(".dropdown__option-label span")
            .remove();

          $.each(option2_not_available, function (indx, option_val) {
            option2_inputs.each(function () {
              var current_option_input = $(this);

              if (current_option_input.val() === option_val) {
                current_option_input
                  .parent(".swatch-element")
                  .addClass("swatch--unavailable");
                current_option_input
                  .parent(".dropdown__option")
                  .addClass("dropdown__option--sold-out")
                  .find(".dropdown__option-label")
                  .append(
                    "<span>Sold Out </span><span>Notify Me When Available</span>"
                  );
              }
            });
          });
        }
      },

      _buildImgUrl: function (src, size) {
        // set a sensible default
        var replaceSize = size || "900x";

        // remove version parameter if exists
        src = src.split("?")[0];

        // get index of file extension so we can insert size before
        var ext_index = src.match(/(\.[\w\d_-]+)$/i).index;

        // return our rebuilt src url
        return (
          src.slice(0, ext_index) + "_" + replaceSize + src.slice(ext_index)
        );
      },
      _buildImage: function (media) {
        var figure = document.createElement("figure");
        var img = document.createElement("img");

        img.src = this._buildImgUrl(media.src, "900x");
        img.srcset =
          this._buildImgUrl(media.src, "900x") +
          " 1x, " +
          this._buildImgUrl(media.src, "1800x") +
          " 2x";

        figure.classList.add("swiper-slide");

        figure.appendChild(img);
        return figure;
      },
      _buildVideo: function (media) {
        var figure = document.createElement("figure");
        var video = document.createElement("video");

        video.playsinline = true;
        video.controls = true;
        video.poster = media.preview_image.src;

        media.sources.forEach(function (src) {
          var source = document.createElement("source");
          source.src = src.url;
          source.type = src.mime_type;
          video.appendChild(source);
        });

        figure.classList.add("swiper-slide");

        figure.appendChild(video);
        return figure;
      },
      _buildExternalVideo: function (media) {
        var figure = document.createElement("figure"),
          container = document.createElement("div"),
          iframe = document.createElement("iframe");

        figure.classList.add("swiper-slide");
        container.classList.add("gallery-video-container");
        iframe.title = media.alt ? media.alt : this.data.title;
        iframe.allowfullscreen = "allowfullscreen";
        iframe.allow =
          "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
        iframe.frameborder = "0";
        iframe.src =
          "https://www.youtube.com/embed/" +
          media.external_id +
          "?controls=1&amp;enablejsapi=1&amp;modestbranding=1&amp;playsinline=1&amp;rel=0";

        container.appendChild(iframe);
        figure.appendChild(container);
        return figure;
      },
      _getMediaEl: function (media) {
        var el = null;

        switch (media.media_type) {
          case "image":
            el = this._buildImage(media);
            break;
          case "video":
            el = this._buildVideo(media);
            break;
          case "external_video":
            el = this._buildExternalVideo(media);
            break;
        }

        return el;
      },
      _updateMedia: function (e) {
        var variant = e.variant;
        var images = $(".product__part--gallery figure");
        var thumbs = $(".gallery-thumb");
        var currentColor = variant.option1.toLowerCase().replace(/ /g, "-");

        thumbs.each(function (index, el) {
          var $el = $(el);
          var imageColor = $el.data("image-color");

          if (imageColor !== "all" && imageColor !== currentColor) {
            $el.hide();
          } else {
            $el.show();
          }
        });

        images.each(function (indx, img) {
          var $img = $(img);
          if (
            variant.featured_media &&
            variant.featured_media.id === parseInt($img.data("image-id"))
          ) {
            REBASE.theme.product_photo_gallery.slideTo(
              parseInt(variant.featured_media.position)
            );
          }
        });
      },
    });

    return Product;
  })();

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product Variants class - based on Shopify debut
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Variants = (function () {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.single_option_selector = options.single_option_selector;
      this.original_select_id = options.original_select_id;
      this.enable_history_state = options.enable_history_state;
      this.current_variant = {};

      $(this.single_option_selector, this.$container).on(
        "change",
        this._onSelectChange.bind(this)
      );
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function () {
        var should_filter = false,
          the_options = $.map(
            $(this.single_option_selector, this.$container),
            function (element) {
              var $element = $(element),
                type = $element.attr("type"),
                current_option = {};

              if (type === "radio" || type === "checkbox") {
                should_filter = true;

                if ($element[0].checked) {
                  current_option.value = $element.val();
                  current_option.index = $element.data("index");
                  return current_option;
                } else {
                  return false;
                }
              } else {
                current_option.value = $element.val();
                current_option.index = $element.data("index");
                return current_option;
              }
            }
          );

        // Remove any unchecked input values if using radio buttons or checkboxes
        // Removes all falsy values (Boolean constructor is a function, if the value is omitted or is 0, -0, null, false, NaN, undefined, or the empty string ("") then it will get removed)
        if (should_filter) {
          the_options = the_options.filter(Boolean);
        }

        return the_options;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selected_values - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function () {
        var selected_values = this._getCurrentOptions(),
          variants = this.product.variants,
          all_variants_match_option1,
          found;

        found = $.grep(variants, function (variant) {
          return selected_values.every(function (values) {
            return variant[values.index] === values.value;
          });
        });

        all_variants_match_option1 = $.grep(variants, function (variant) {
          return variant[selected_values[0].index] === selected_values[0].value;
        });

        if (found.length) {
          found = found[0];
        } else {
          found = undefined;
        }

        return {
          variant_match: found,
          all_variants_match_option1: all_variants_match_option1,
        };
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function (e) {
        var variant_from_options = this._getVariantFromOptions(),
          variant;

        variant = variant_from_options.variant_match;

        this.$container.trigger({
          type: "variantChange",
          variant: variant,
          all_variants_match_option1:
            variant_from_options.all_variants_match_option1,
          target: e.target,
        });

        if (!variant) {
          this.current_variant = {};
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.current_variant = variant;

        if (this.enable_history_state) {
          this._updateHistoryState(variant);
        }
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function (variant) {
        var variant_image = variant.featured_image || {},
          current_variant_image = this.current_variant.featured_image || {};

        if (
          !variant.featured_image ||
          variant_image.src === current_variant_image.src
        ) {
          return;
        }

        this.$container.trigger({
          type: "variantImageChange",
          variant: variant,
        });
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function (variant) {
        if (
          variant.price === this.current_variant.price &&
          variant.compare_at_price === this.current_variant.compare_at_price
        ) {
          return;
        }

        this.$container.trigger({
          type: "variantPriceChange",
          variant: variant,
        });
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function (variant) {
        if (variant.sku === this.current_variant.sku) {
          return;
        }

        this.$container.trigger({
          type: "variantSKUChange",
          variant: variant,
        });
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function (variant) {
        $(this.original_select_id, this.$container).val(variant.id);
        $("#product-supplier-style").text(
          $("option:selected", this.original_select_id, this.$container).data(
            "variant-ss"
          )
        );
      },
    });

    return Variants;
  })();
})(jQuery);
